import { dissoc, merge, reject, propEq, findIndex, append, update, defaultTo, any, propIs, find } from 'ramda';
import { createSelector } from 'reselect';
import { combineActions, createActions, handleActions } from 'redux-actions';

var _handleActions;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var websockets = require('@rushplay/websockets');

var initialState = {
  items: [],
  selectedItem: undefined
};

var actions = createActions({
  store: {
    CLEAR: function CLEAR() {
      return { selectedItem: undefined };
    },
    SELECT: function SELECT(id) {
      return { id: id };
    },
    UPDATE: function UPDATE(items) {
      return { items: items };
    },
    STORE_ITEM_UPDATED: function STORE_ITEM_UPDATED(item) {
      return item;
    },
    STORE_ITEM_DELETED: function STORE_ITEM_DELETED(id) {
      return id;
    }
  }
});

var combinedStoreItemDeleted = combineActions(websockets.STORE_ITEM_DELETED, actions.store.storeItemDeleted);

var combinedStoreItemUpdated = combineActions(websockets.STORE_ITEM_UPDATED, actions.store.storeItemUpdated);

/**
 * @returns {function} reducer
 */
var reducer = handleActions((_handleActions = {}, _defineProperty(_handleActions, actions.store.clear, function (state) {
  return dissoc('selectedItem', state);
}), _defineProperty(_handleActions, actions.store.select, function (state, action) {
  return merge(state, { selectedItem: action.payload.id });
}), _defineProperty(_handleActions, actions.store.update, function (state, action) {
  return merge(state, { items: action.payload.items });
}), _defineProperty(_handleActions, combinedStoreItemDeleted, function (state, action) {
  return merge(state, {
    items: reject(propEq('id', action.payload), state.items)
  });
}), _defineProperty(_handleActions, combinedStoreItemUpdated, function (state, action) {
  var index = findIndex(propEq('id', action.payload.id), state.items);

  return merge(state, {
    items: index === -1 ? append(action.payload, state.items) : update(index, action.payload, state.items)
  });
}), _handleActions), initialState);

/**
 * @param  {object} state
 * @returns {array}
 */
var EMPTY_ITEMS = [];
var getItems = createSelector([function (state) {
  return state.items;
}], defaultTo(EMPTY_ITEMS));

/**
 * @param  {object} state
 * @returns {boolean}
 */
function isSale(state) {
  return any(propIs(Number, 'discount'), state.items);
}

/**
 * @param {object} state
 * @returns {boolean}
 */
function isAnyItemSelected(state) {
  return state.selectedItem != null;
}

/**
 * @param  {object} state
 * @param  {object} key
 * @returns {boolean}
 */
function isSelected(state, id) {
  return state.selectedItem === id;
}

/**
 * @param {any} state
 * @returns {object}
 */
function getSelectedItem(state) {
  return find(propEq('id', state.selectedItem), state.items);
}

/**
 * Action creator. Reset selected item.
 * @returns {FSA}
 */
var clear = actions.store.clear;

/**
 * Action creator. Remove item matching id.
 * @param {number} id
 * @returns {FSA}
 */
var storeItemDeleted = actions.store.storeItemDeleted;

/**
 * Action creator. Reset selected item.
 * @param {any} id
 * @returns {FSA}
 */
var select = actions.store.select;
/**
 * Action creator. Store the payload.
 * @param {array} items
 * @returns {FSA}
 */

var update$1 = actions.store.update;

/**
 * Action creator. Replace item matching the id of the item in the payload.
 * @param {object} item
 * @returns {FSA}
 */
var storeItemUpdated = actions.store.storeItemUpdated;

export { reducer, getItems, isSale, isAnyItemSelected, isSelected, getSelectedItem, clear, storeItemDeleted, select, update$1 as update, storeItemUpdated };
